import { InputAdornment } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import CustomTextField from 'pages/UsersAvailability/DatePicker/CustomTextField';

const DobField = (props: any) => {
  const {
    fullWidth,
    onChange,
    value,
    error,
    helperText,
    required = false,
  } = props;
  //
  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DesktopDatePicker
          format="dd.MM.yyyy" // Set the desired date format here
          timeZone="America/Los_Angeles"
          locale="en-US"
          value={value}
          onChange={onChange}
          maxDate={new Date()}
          {...props}
          renderInput={(params: any) => (
            <CustomTextField
              required={required}
              {...params}
              fullWidth={fullWidth}
              error={error}
              helperText={helperText}
              ref={params.inputRef}
              endAdornment={
                <InputAdornment position="end">
                  {params.InputProps?.endAdornment}
                </InputAdornment>
              }
            />
          )}
        />
      </LocalizationProvider>
    </>
  );
};

export default DobField;
